import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

const getDefaultSelectedResourceGroup = () => {
  return {
    resources: [],
  };
};
export default {
  state: () => ({
    selectedResourceGroup: getDefaultSelectedResourceGroup(),
    resourceGroups: [],
  }),

  mutations: {
    setSelectedResourceGroup(state, resourceGroup) {
      Vue.set(state, "selectedResourceGroup", resourceGroup);
    },
    setResourceGroups(state, resourceGroups) {
      Vue.set(state, "resourceGroups", resourceGroups);
    },
    setDefaultSelectedResourceGroup(state) {
      Vue.set(state, "selectedResourceGroup", getDefaultSelectedResourceGroup());
    },
    setDefaultResourceGroupModule(state) {
      Vue.set(state, "selectedResourceGroup", getDefaultSelectedResourceGroup());
      Vue.set(state, "resourceGroups", []);
    },
  },

  actions: {
    //TODO: load, update, create
    createResourceGroup: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/resource-groups/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadResourceGroups: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/resource-groups/entity").then((response) => {
        context.commit("setSelectedResourceGroup", response.data);
        return objectUtils.convertPublishModelToUpdateModel(response.data);
      });
    },

    loadResourceGroup: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/resource-groups/entity/" + request.id).then((response) => {
        context.commit("setSelectedResourceGroup", response.data);
      });
    },

    loadPublishedResourceGroups: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/resource-groups/entity/published").then((response) => {
        return response.data;
      });
    },

    loadSelectedResourceGroupHistory: (context, resourceGroup) => {
      return axios.get(context.getters.getMcServiceUrl + "/resource-groups/history/" + resourceGroup.id, {}).then((response) => {
        return response.data;
      });
    },

    deleteResourceGroup: (context, resourceGroup) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/resource-groups/entity/" + resourceGroup.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          resourceGroup.intents = intents;
          resourceGroup.intentId = response.data.id;
          return resourceGroup;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftResourceGroup: (context, resourceGroup) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/resource-groups/draft/" + resourceGroup.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishResourceGroup: (context, resourceGroup) => {
      return axios.get(context.getters.getMcServiceUrl + "/resource-groups/publish/" + resourceGroup.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        //Fixme: intents type CREATE_STATION ise get isteği atılmalı.
        if (resourceGroup.intents[0].type === "DELETE_RESOURCE_GROUP") {
          let resourceGroups = context.getters.getSegments;
          resourceGroups.splice(resourceGroups.indexOf(resourceGroup), 1);
          context.commit("setResourceGroups", resourceGroups);
        }
        return response.data;
      });
    },

    rejectResourceGroup: (context, resourceGroup) => {
      return axios.get(context.getters.getMcServiceUrl + "/resource-groups/reject/" + resourceGroup.intentId).then((response) => {
        helper.recallOrRejectEntity(resourceGroup, "resourceGroups");
        return response.data;
      });
    },

    sendToApprovalResourceGroups: (context, resourceGroup) => {
      return axios.get(context.getters.getMcServiceUrl + "/resource-groups/sendToApproval/" + resourceGroup.intentId).then((response) => {
        if (resourceGroup.intents[0].type === "CREATE_RESOURCE_GROUP") {
          resourceGroup.intents[0].status = "WAITING_APPROVAL";
        } else if (resourceGroup.intents[0].type === "UPDATE_RESOURCE_GROUP") {
          resourceGroup.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallResourceGroup: (context, resourceGroup) => {
      return axios.get(context.getters.getMcServiceUrl + "/resource-groups/recall/" + resourceGroup.intentId).then((response) => {
        helper.recallOrRejectEntity(resourceGroup, "resourceGroups");
        return response.data;
      });
    },

    cancelResourceGroup: (context, resourceGroup) => {
      return axios.get(context.getters.getMcServiceUrl + "/resource-groups/cancel/" + resourceGroup.intentId).then((response) => {
        return response.data;
      });
    },
  },

  getters: {
    getSelectedResourceGroup: (state) => {
      return state.selectedResourceGroup;
    },
    getResourceGroups: (state) => {
      return state.resourceGroups;
    },
  },
};
